(() => {
  function init(root = document) {
    root.querySelectorAll('[data-retailers]').forEach(locator => {
      if (locator.dataset.ready) return;
      locator.dataset.ready = 'true';
      const input = locator.querySelector('[data-store-search]');
      const buttons = [...locator.querySelectorAll('[data-store-region]')];
      let region = '';
      const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('fr');
      const update = () => {
        let count = 0;
        locator.querySelectorAll('[data-store]').forEach(store => {
          const visible = (!region || store.dataset.region === region) && normalize(store.textContent).includes(normalize(input.value.trim()));
          store.hidden = !visible;
          if (visible) count++;
        });
        locator.querySelectorAll('[data-region-group]').forEach(group => { group.hidden = !group.querySelector('[data-store]:not([hidden])'); });
        locator.querySelector('[data-store-count]').textContent = (count === 1 ? locator.dataset.countOne : locator.dataset.countOther).replace('__COUNT__', count);
        locator.querySelector('[data-store-empty]').hidden = count > 0;
      };
      input.addEventListener('input', update);
      buttons.forEach(button => button.addEventListener('click', () => {
        region = button.dataset.storeRegion;
        buttons.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        update();
      }));
      update();
    });
    root.querySelectorAll('[data-editorial-article]').forEach(article => {
      const toc = article.querySelector('[data-article-toc]');
      if (toc.dataset.ready) return;
      toc.dataset.ready = 'true';
      const headings = article.querySelectorAll('[data-article-body] h2');
      headings.forEach((heading, i) => {
        if (!heading.id) heading.id = `article-chapter-${i + 1}`;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        toc.append(link);
      });
      toc.hidden = !headings.length;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
